/**
 * One-time pdfjs-dist worker setup.
 *
 * The worker URL needs to be resolved relative to the Vite-bundled module so
 * the bundler can fingerprint and serve it; doing this at module scope means
 * we set it exactly once even if multiple components ask for the library.
 *
 * Returns the loaded library so callers can `await` the dynamic import in
 * one place. We dynamic-import to keep pdf.js out of the initial bundle —
 * it's only needed inside the document-sign editor.
 */

type PdfJsModule = typeof import('pdfjs-dist');

let cached: Promise<PdfJsModule> | null = null;

export function loadPdfJs(): Promise<PdfJsModule> {
  if (!cached) {
    cached = (async () => {
      const pdfjs = await import('pdfjs-dist');
      pdfjs.GlobalWorkerOptions.workerSrc = new URL(
        'pdfjs-dist/build/pdf.worker.min.mjs',
        import.meta.url,
      ).toString();
      return pdfjs;
    })();
  }
  return cached;
}
